<div style="font-family: sans-serif;">

  <!-- Hero Section -->
  <div class="bg-[#faf8f5] py-10 sm:py-14 text-center border-b border-gray-200">
    <h1 class="text-2xl sm:text-3xl font-bold text-gray-900 tracking-wide" style="font-family: 'Roboto Slab', serif;">About Us</h1>
    <div class="flex items-center justify-center gap-2 mt-3">
      <div class="w-8 h-[2px] bg-[#600b0b]"></div>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
      <div class="w-8 h-[2px] bg-[#600b0b]"></div>
    </div>
  </div>

  <!-- Intro -->
  <div class="max-w-[1000px] mx-auto px-4 sm:px-6 py-8 sm:py-12 text-center">
    <p class="text-sm sm:text-[15px] text-gray-600 leading-relaxed">
      With MahattaArt.com, We are working towards a goal to re-define the whole experience of transforming walls as easy and convenient affair for each & every buyer, by giving an easy access to incredible design concepts and products at one platform. Be it a design inspiration or an exact style – we're sure to get you the concept that you're curious to have on your walls. We give an access to end to end services, from concept designing to product development to
      <a routerLink="/listing" class="text-[#600b0b] font-semibold hover:underline">installation on your walls</a>.
    </p>
  </div>

  <!-- Who We Are + Why Us -->
  <div class="max-w-[1100px] mx-auto px-4 sm:px-6 pb-12 sm:pb-16">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">

      <!-- Who We Are -->
      <div>
        <h2 class="text-xl sm:text-2xl font-bold text-[#600b0b] mb-4" style="font-family: 'Roboto Slab', serif;">Who We Are?</h2>
        <p class="text-sm text-gray-600 leading-relaxed mb-4">
          MahattaArt.com has its roots from history, Mahatta Group which has 100+ years of experience in photography, and with being evolved to digital technology in 2002, the successful 15+ years in online image stock licensing business with creative designers, advertising agencies, corporates professionals & more, Mahatta has introduced Mahatta Art as an initiative to address an unorganized industry of Wall Decors, where –
        </p>
        <ul class="space-y-2 text-sm text-gray-600">
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Identifying the right professionals for design selection.
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Right place for purchase.
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Fair <a routerLink="/listing" class="text-[#600b0b] font-semibold hover:underline">quotes</a>.
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Assured quality & installation, and above all coordinating with all the personnel were a major pain point.
          </li>
        </ul>
        <p class="text-sm text-gray-600 leading-relaxed mt-4">
          With this unparallel experience and pivotal need to address the issue, Mahattaart.com, an online platform with a unique proposition was introduced with all the key experience and offerings at one place.
        </p>
      </div>

      <!-- Why Us -->
      <div>
        <h2 class="text-xl sm:text-2xl font-bold text-[#600b0b] mb-4" style="font-family: 'Roboto Slab', serif;">Why Us?</h2>
        <ul class="space-y-2.5 text-sm text-gray-600">
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Hassle Free Wall decors from Concept to Execution under one roof
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Wall Decor Consultation
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            1000+ catalogue design concepts for every wall decor & space
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Custom Made Designs
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Style, Innovation & quality work
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Product Variety
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Licensed Artworks
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Custom sizes, & finish variety
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Affordable Price
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Team of experts – Interior designers, concept designers & art researchers
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Door-step delivery & <a routerLink="/listing" class="text-[#600b0b] font-semibold hover:underline">installations</a>
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            After sales Support
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            10+ years experienced craftsman
          </li>
          <li class="flex items-start gap-2">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] mt-1.5 shrink-0"></span>
            Pan India Shipping
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- CTA Banner -->
  <div class="bg-[#600b0b]">
    <div class="max-w-[1100px] mx-auto px-4 sm:px-6 py-8 sm:py-10 flex flex-col md:flex-row items-center justify-between gap-6">
      <div>
        <h3 class="text-xl sm:text-2xl font-bold text-white" style="font-family: 'Roboto Slab', serif;">Transforming Your Wall Is Just A Click Away!</h3>
        <p class="text-white/80 text-xs sm:text-sm mt-2 leading-relaxed max-w-[700px]">
          "For decorating a new place or upgrading a room decor, adding a concept that you love is not only a great way to decorate but also to say something about yourself. Art is a powerful source of your representation in your house & a touch of art in your space is a way for inspiration, positivity in life."
        </p>
      </div>
      <a routerLink="/contact"
        class="border-2 border-white text-white px-8 py-3 text-xs font-bold uppercase tracking-[0.2em] hover:bg-white hover:text-[#600b0b] transition-all shrink-0">
        Contact Now
      </a>
    </div>
  </div>
</div>
